<template>
  <div class="common-wrap">
    <action-bar>
      <search placeholder="请输入ID/名称搜索" @onSearch="onSearch"></search>
      <btn-style v-if="showGenAll" :btn-list="btnList"></btn-style>
    </action-bar>
    <common-bg-plate>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          v-if="$utils.hasAuth($store, auth.certificate.IBCAuth.orgCert)"
          label="IBC组织证书"
          name="organization"
        >
          <organization ref="organization"></organization>
        </el-tab-pane>
        <el-tab-pane
          v-if="$utils.hasAuth($store, auth.certificate.IBCAuth.nodeCert)"
          label="IBC节点证书"
          name="node"
        >
          <node ref="node"></node>
        </el-tab-pane>
        <el-tab-pane
          v-if="$utils.hasAuth($store, auth.certificate.IBCAuth.userCert)"
          label="IBC用户证书"
          name="user"
        >
          <user ref="user"></user>
        </el-tab-pane>
      </el-tabs>
    </common-bg-plate>
    <gen-all ref="genAll" @update:list="getList()"></gen-all>
  </div>
</template>

<script>
import organization from './organization'
import node from './node'
import user from './user'
import genAll from './components/genAll'
import { mapActions } from 'vuex'
import auth from '@/auth/index'
export default {
  name: 'Index',
  components: {
    organization,
    node,
    user,
    genAll
  },
  data() {
    return {
      activeName: 'organization',
      auth: auth,
      btnList: [
        {
          btnContent: '生成所有证书',
          click: () => {
            return this.genAllCert()
          },
          icon: 'icon-add'
        }
      ]
    }
  },
  computed: {
    showGenAll() {
      return (
        this.$utils.hasAuth(this.$store, auth.certificate.IBCAuth.orgCert.createOrgCert) &&
        this.$utils.hasAuth(this.$store, auth.certificate.IBCAuth.nodeCert.createNodeCert) &&
        this.$utils.hasAuth(this.$store, auth.certificate.IBCAuth.userCert.createUserCert)
      )
    }
  },
  mounted() {
    let active = this.$route.query.active
    active ? (this.activeName = active) : (this.activeName = 'organization')
  },
  methods: {
    ...mapActions(['getOrgLists', 'getNodeLists', 'getUserLists']),
    handleClick(tab) {
      this.$refs[tab?.name]?.refresh()
    },
    getList(limit = 20, offset = 0) {
      this.$refs.organization.getList(limit, offset)
      this.$refs.node.getList(limit, offset)
      this.$refs.user.getList(limit, offset)

      this.$message.success('生成所有证书成功，列表已刷新')
    },
    genAllCert() {
      this.$refs.genAll.handleOpen()
    },
    onSearch(inputValue) {
      this.$refs[this.activeName]?.getList(20, 0, inputValue)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

.common-certificate {
  @include adaptation(
    (
      --common-certificate-list-unavailable-height: 111px,
      --common-certificate-list-status-padding: 2px 8px,
    )
  );
  --common-certificate-list-min-height: calc(var(--base-main-router-body-avaliable-height-with-action-bar) - var(--common-certificate-list-unavailable-height));
}
</style>
